export default {
  getReportList: state => {
    return state.reportList
  },
  getStatisticValues: state => {
    return state.statisticValues
  },
  getControls: state => {
    const controls = []
    if (state.errors.controls !== null) {
      state.errors.controls.map(item => {
        controls.push({ controlValue: item.controlValue, noteMessage: item.noteMessage, description: '' })
      })
      return controls
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reporting/getters.js